export const TITLE = _TL_('Auto Apply Recommendation Bulk Update Tool');
export const HINT = _TL_('You can reference the sample payload below to prepare your CSV file to be uploaded.');
export const DESCRIPTION = _TL_('Please prepare a csv file with three columns "Account ID", "Recommendation Type" and "Opt-in status". Fill up the values of each row following the instructions below.\nTo avoid naming confusion, suggest following the convention below to name your file each time:\n\nAAR_update_yyyy_mm__dd.csv');
export const UPLOAD_COMFIRM = _TL_('You are trying to make {{number}} updates, please confirm that you will make the change.');

export const LIMIT_UPLOAD_NUMBER = 2000;
export const INSTRUCTION_STRINGS = {
  LIMIT: _TL_('Don\'t include more than {{number}} account id in each individual CSV file.'),
  ACCOUNT_ID: _TL_('Column "Account ID" requires a numeric value. For example, 35000220 is valid, but B00573KQ is not.'),
  RECOMMENDATION_TYPE: _TL_('Column "Recommendation Type" requires a valid value that must be selected from the following sample list. Any other texts are not accepted.'),
  OPTIN_STATUS: _TL_('Column "Opt-in status" requires a "YES" or "NO" text value. Setting it to "YES" means to opt-in, and "NO" to opt-out.'),
};
export const STEP_STRINGS = [
  _TL_('Check the file format as well as the content. You may get error message if the format is not in CSV or the content is invalid.'),
  _TL_('Upload the CSV file to remote server where we store it temporarily.'),
  _TL_('Validate the account list that current user has access to update status for. You will get error prompts if you don\'t have corresponding access.'),
  _TL_('Apply the changes for you.'),
];

export const SUPPORT_RECOMMENDATION_TYPE_TITLE = [
  'Create responsive search ads',
  'Create multimedia ads',
  'Fix conversion goal setting issues',
  'Remove negative keyword conflicts',
  'Create conversion goal',
  'Repair missing keyword param issue',
];

export const SAMPLE_TABLE_DATA = [
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[0],
    optIn: 'YES',
  },
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[1],
    optIn: 'NO',
  },
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[2],
    optIn: 'YES',
  },
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[3],
    optIn: 'NO',
  },
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[4],
    optIn: 'YES',
  },
  {
    accountId: '35000220',
    recommendationType: SUPPORT_RECOMMENDATION_TYPE_TITLE[5],
    optIn: 'YES',
  },
];
